import type { WebshopStoreType } from '../../reducers/webshop/webshop'
import type { BasketItem } from '../../../schema/basket'
import type { State } from '../../reducers'
import type { WebshopPackage } from '../../../schema/webshop-package'

export const selectWebshop = (state: State): WebshopStoreType => state.webshop
export const selectWebshopInOrder = (state: State): BasketItem[] => state.webshop.inOrder
export const selectPopulars = (state: State): WebshopPackage[] => {
  let codes = []
  if (process.env.NODE_ENV === 'production') {
    codes = [
      'STAND-NVB-BASIS-0-1',
      'PACKAGE-NVB-BASIS-VACATURE-PLUS-CAMPAGNEBUDGET-450',
      'Stand-NVB-CvDatabase-100credits-0-1',
      'PACKAGE-NVB-STANDAARD-VACATURE-PLUS-CAMPAGNEBUDGET-300',
      'PACKAGE-NVB-LOGO-VACATURE-PLUS-CAMPAGNEBUDGET-450'
    ]
  } else if (process.env.NODE_ENV === 'test') {
    codes = []
  } else if (process.env.NODE_ENV === 'development') {
    codes = [
      'STAND-NVB-BASIS-0-1',
      'PACKAGE-NVB-BASIS-VACATURE-PLUS-CAMPAGNEBUDGET-450',
      'Stand-NVB-CvDatabase-100credits-0-1',
      'PACKAGE-NVB-Topbaan-Booster-Large',
      'PACKAGE-INT-NVB-Topbaan-Booster-Large',
      'PACKAGE-NVB-Logo-Booster-Medium'
    ]
  }

  return state.webshop.packages.filter(p => codes.includes(p.productCode))
}

/**
 * @returns Suggested product relative to the provided product (id)
 */
export const selectOtherProduct = (currentProductId?: string) => (state: State): WebshopPackage => {
  const otherProductCode = currentProductId === 'STAND-NVB-BASIS-0-1' ? 'PACKAGE-NVB-UITGELICHTE-VACATURE-PLUS-CAMPAGNEBUDGET-550' : 'STAND-NVB-BASIS-0-1'

  return state.webshop.packages.find(product => product.productCode === otherProductCode)
}
